<template>
    <component v-bind:is="vueName"></component>
</template>
<script>
import Error from './ErrorRouter.vue'
import $ from 'jquery';

window.addEventListener("scroll", function() {

    var pBottom = window.document.getElementById('product').getBoundingClientRect().bottom;
    var right_top = window.document.getElementById('right').getBoundingClientRect().top;
    var right = window.document.getElementById('right').getBoundingClientRect().bottom;
    var footer = window.document.getElementById('footer').getBoundingClientRect().top;
    var container = window.document.getElementById('main-contant').getBoundingClientRect().bottom;

    ///////////////프로덕트 인포
    if(pBottom <= 56) {
        window.document.getElementById('select-menu-box').style.display = "none";
        window.document.getElementById('product-title-change').style.display = "flex";
        window.document.getElementById('productInfo').style.position = "fixed";
        window.document.getElementById('productInfo').style.top = "56px";
        window.document.getElementById('productInfo').style.zIndex = "800";
        window.document.getElementById('productInfo').style.background = "#fff";
        window.document.getElementById('productInfo').style.height = "5.9rem";
        let aElemenets = document.querySelectorAll(".product_info_menu");

        for(let i = 0; i < aElemenets.length; i++) {
            aElemenets[i].style.lineHeight = "6rem";
            aElemenets[i].style.paddingBottom = "1.2rem";
        }

    } else {
        window.document.getElementById('product-title-change').style.display = "none";
        window.document.getElementById('select-menu-box').style.display = "flex";
        window.document.getElementById('productInfo').style.position = "static";
        window.document.getElementById('productInfo').style.top = "auto";
        window.document.getElementById('productInfo').style.zIndex = "-2";
        window.document.getElementById('productInfo').style.background = "none";
        window.document.getElementById('productInfo').style.height = "10rem";
        let aElemenets = document.querySelectorAll(".product_info_menu");

        for(let i = 0; i < aElemenets.length; i++) {
            aElemenets[i].style.lineHeight = "10rem";
            aElemenets[i].style.paddingBottom = "3.2rem";
        }
    }



    ///////////////right
    if(window.innerWidth > 1200) {
        if(pBottom <= 56) { //프로덕트 요소 바닥이 56(서브메뉴 높이)보다 작아질 때
            if(container >= window.innerHeight) { //푸터가 윈도우창보다 아래에 있어서 화면 밖에 있을 때
                    window.document.getElementById("right").style.position = "fixed";
                    window.document.getElementById("right").style.display = "inline";
                    window.document.getElementById("right").style.marginLeft = "7em";
                    window.document.getElementById("right").style.marginTop = "-6.5em";
                    window.document.getElementById("right").style.top = "25em";
                    window.document.getElementById('right').style.bottom = "auto";
            } else {
                if(right > container) {
                    // console.log("아래로 넘어감!" + right_top);

                    window.document.getElementById('right').style.top = "";
                    window.document.getElementById('right').style.bottom = "0";
                    window.document.getElementById('right').style.position = "absolute";
                } else {
                    if(right_top < 260) {
                        window.document.getElementById('right').style.top = "";
                        window.document.getElementById('right').style.bottom = "0";
                        window.document.getElementById("right").style.marginLeft = "7em";
                        window.document.getElementById("right").style.display = "inline";
                        window.document.getElementById('right').style.position = "absolute";
                        return;
                    }
                    window.document.getElementById("right").style.position = "fixed";
                    window.document.getElementById("right").style.display = "inline";
                    window.document.getElementById("right").style.marginLeft = "7em";
                    window.document.getElementById("right").style.marginTop = "-6.5em";
                    window.document.getElementById("right").style.top = "25em";
                    window.document.getElementById('right').style.bottom = "auto";
                }
            }
        } else {
            window.document.getElementById("right").style.position = "static";
            window.document.getElementById("right").style.display = "block";
            window.document.getElementById("right").style.marginLeft = "0";
            window.document.getElementById("right").style.marginTop = "13.4rem";
        }
    }

});


export default {
    components: {
        Error,
    },
    data: () => {
        return {
            langcode: '',
            biztype: '',
            prodid: '',
            vueName: () => ({}),
            showNavbar: true,
            lastScrollPostion: 0,
        }
    },
    created: function() {
        // this.langcode = this.$route.params.langcode;
        this.biztype = this.$route.params.biztype;
        this.prodid = this.$route.params.prodid;
        this.loadComponent();
    },
    mounted: function() {
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('scroll', this.onScroll);

    },
    beforeDestroy () {
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
        handleResize() {
            window.document.getElementById("right").style.position = "static";
            window.document.getElementById("right").style.display = "block";
            window.document.getElementById("right").style.marginLeft = "0";
            window.document.getElementById("right").style.marginTop = "13.4rem";
        },
        onScroll() {
            const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            if (currentScrollPosition < 0) {
                return
            }
            if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
                return
            }
            this.showNavbar = currentScrollPosition < this.lastScrollPosition;
            this.lastScrollPosition = currentScrollPosition;

            var header = window.document.getElementById('header');
            var title_top = window.document.getElementById('product').getBoundingClientRect().top;
            var subMenu = window.document.getElementById('subMenu');
            if(this.showNavbar) { //스크롤 올릴때
                if(title_top >= 56) {
                    header.style.display = "block";
                    subMenu.style.top = "auto";
                }
                window.document.getElementById('productInfo').style.top = "56px";

            } else {
                header.style.display = "none";
                subMenu.style.top = "0";
                window.document.getElementById('productInfo').style.top = "56px";
            }
        },
        loadComponent() {
                if(this.$route.name == 'krProdunct') {
                    this.langcode = 'kr';
                } else {
                    this.langcode = 'en';
                }
                // let newProdid = this.prodid.substr(this.prodid.indexOf('_') + 1);
                // let ProdVue = newProdid.charAt(0).toUpperCase() + newProdid.slice(1);
                let ProdVue = this.prodid.charAt(0).toUpperCase() + this.prodid.slice(1);
                // this.vueName = this.langcode + this.biztype + newProdid;
                this.vueName = () => ({
                    component: import("@/views/" + this.langcode + "/" + this.biztype + "/" + ProdVue),
                    loading: true,
                    error: Error,
                })
        },
    }
}
// $(window).scroll(function(){
//     $('#right').css('left', 0-$(this).scrollLeft());
// });
</script>